import Swiper, { Navigation, Pagination, Autoplay, Keyboard} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Keyboard]);

function getKeyByValue(object, value) {

    for (const [key, val] of Object.entries(object)) {

        if(val.value == value) {
            return key;
            break;
        }
    }

    return false;
}


let searchString = location.search.substring(1);
let searchObjectPhilately = {};
if(searchString.length>0) {

    searchObjectPhilately = JSON.parse(
        '{"' + searchString.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
        function(key, value) {
            return key===""?value:decodeURIComponent(value);
        }
    );

}

new Swiper(".js-service-slider-search", {
    on: {
        beforeInit: function () {

            let keySearch = 0;
            keySearch = (this.$el[0].dataset.initialslide!==undefined) ? this.$el[0].dataset.initialslide : keySearch;

            if(window.location.search.length>1) {
                keySearch = (undefined===searchObjectPhilately.y) ? 0 : getKeyByValue( document.querySelectorAll('.swiper-wrapper input'), searchObjectPhilately.y );
            }
            this.params.initialSlide = keySearch;

        },
    },
    loop: false,
    slidesPerView: 2,
    spaceBetween: 20,
    centerInsufficientSlides: true,
    keyboard: {
        enabled: true
    },
    breakpoints: {
        420: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 4,
        },
        640: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 6,
        },
        1024: {
            slidesPerView: 9,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next-pp",
        prevEl: ".swiper-button-prev-pp",
    },
});

let formSearch = document.querySelector('#philatelySearchForm');



// formSearch.addEventListener('submit',
//     function (event) {
//
//         if (event.submitter.matches('#philatelySearchFormButton')) {
//             event.preventDefault();
//
//             let yearRadioInput = document.querySelectorAll('.swiper-wrapper input:checked');
//             let philatelySearchFormInput = document.querySelector('#philatelySearchFormInput');
//
//             if(1===yearRadioInput.length){
//                 philatelySearchFormInput.value = philatelySearchFormInput.value.replace(/(<([^>]+)>)/gi, "");
//                 //console.log( philatelySearchFormInput.value );
//                 window.location.search = `y=${yearRadioInput[0].value}&sf=${philatelySearchFormInput.value}`;
//             } else if(yearRadioInput.length>1) {
//                 console.log('nie przygotowane na wybor wielu lat');
//             } else {
//                 console.log('nie przygotowane na brak wyboru');
//             }
//
//         }
//
//     }
// );
